var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trainer)?_c('div',{staticClass:"wrap-item-trainer"},[_c('div',{staticClass:"f fm"},[_c('v-icon',{staticClass:"mr8"},[_vm._v("group")]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.trainer.name))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }